export * from '@thesisedu/web/dist/clipboard'
